// engine
import { ArApp, appDispatcher, soundService } from "@aceroll/core";

// layouts
import * as layouts from './layouts';

// platform
import { platform } from "./platform";
import gameLoadedData from './platform/gameLoadedData.json';

// configs
import { appConfig } from './configs/app-config';

// --------- debug --------- //
import { helper } from '@aceroll/core';

(async function () {
	const app = new ArApp();
	await app.setup(appConfig);
	appDispatcher.setState({ app: app }, true);
	app.start();

	// Platform setup
	platform.setGameLoadedData(gameLoadedData);

	/* ADD LAYOUTS */
	Object.keys(layouts).forEach((name) => {
		const layoutName = name.toLowerCase();
		app.addLayout(name, new layouts[name](layoutName));
	});

	if (process?.env?.DEBUG === 'true') {
		globalThis.__PIXI_APP__ = app;
		helper.debug = true;
		window.app = app;
		window.platform = platform;
		window.helper = helper;
		window.soundService = soundService;

		
		// app.layouts['Game'] = app.layouts['DebugSymbols'];
	}
}());
